import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29e70de7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "confirmation-slot" }
const _hoisted_5 = ["checked", "disabled"]
const _hoisted_6 = { class: "confirmation-slot" }
const _hoisted_7 = ["checked", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ConfirmationOverlay = _resolveComponent("ConfirmationOverlay")!
  const _component_SomethingWrongOverlay = _resolveComponent("SomethingWrongOverlay")!

  return (_ctx.confirmationShown())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.popupStage === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_ConfirmationOverlay, {
                acceptTheme: "primary",
                rejectTheme: "return",
                titleText: "Is this trailer still DOT compliant <em>and</em> safe to perform the load with?",
                acceptText: "Confirmed, DOT and safe.",
                rejectText: "No",
                acceptDisabled: _ctx.dotInspectionExpired,
                disabled: _ctx.submitting,
                popupStage: _ctx.popupStage,
                onConfirmStage: _ctx.changeStage
              }, null, 8, ["acceptDisabled", "disabled", "popupStage", "onConfirmStage"])
            ]))
          : (_ctx.popupStage === 2)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_ctx.acceptedFirstStage)
                  ? (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
                      key: 0,
                      acceptTheme: _ctx.damageConfirmed ? 'primary' : 'disabled',
                      rejectTheme: "return",
                      subtitleStyle: "strong-subtitle",
                      titleText: `Please confirm you will take possession despite damage.`,
                      subtitleText: `Please contact ${_ctx.assistanceCompany} once you have dropped this trailer or completed your load. (${_ctx.assistanceNumber})`,
                      acceptText: _ctx.takePossessionAcceptText,
                      rejectText: _ctx.takePossessionRejectText,
                      onAccept: _ctx.onAccept,
                      onReject: _ctx.onReject,
                      rejectionLoading: _ctx.showLoading === 'reject',
                      confirmationLoading: _ctx.showLoading === 'accept',
                      disabled: _ctx.submitting,
                      popupStage: _ctx.popupStage
                    }, {
                      warning: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", {
                            class: "checkbox-container",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmDisclaimer && _ctx.confirmDisclaimer(...args)))
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: _ctx.damageConfirmed,
                              disabled: _ctx.submitting
                            }, null, 8, _hoisted_5)
                          ]),
                          _createTextVNode(" Checking this box will serve as my electronic signature on any Electronic Vehicle Inspections reports generated from this trailer assessment. ")
                        ])
                      ]),
                      _: 1
                    }, 8, ["acceptTheme", "titleText", "subtitleText", "acceptText", "rejectText", "onAccept", "onReject", "rejectionLoading", "confirmationLoading", "disabled", "popupStage"]))
                  : (_openBlock(), _createBlock(_component_ConfirmationOverlay, {
                      key: 1,
                      acceptTheme: _ctx.damageConfirmed ? 'primary' : 'disabled',
                      rejectTheme: "return",
                      subtitleStyle: "warning",
                      titleText: `Will you take possession and contact ${_ctx.assistanceCompany} immediately?<br/> (${_ctx.assistanceNumber})`,
                      acceptText: _ctx.takePossessionAndContactAcceptText,
                      rejectText: _ctx.takePossessionAndContactRejectText,
                      onAccept: _ctx.onAccept,
                      onReject: _ctx.onReject,
                      disabled: _ctx.submitting,
                      rejectionLoading: _ctx.showLoading === 'reject',
                      confirmationLoading: _ctx.showLoading === 'accept',
                      popupStage: _ctx.popupStage
                    }, {
                      warning: _withCtx(() => [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", {
                            class: "checkbox-container",
                            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.confirmDisclaimer && _ctx.confirmDisclaimer(...args)))
                          }, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              checked: _ctx.damageConfirmed,
                              disabled: _ctx.submitting
                            }, null, 8, _hoisted_7)
                          ]),
                          _createTextVNode(" Checking this box will serve as my electronic signature on any Electronic Vehicle Inspections reports generated from this trailer assessment. ")
                        ])
                      ]),
                      _: 1
                    }, 8, ["acceptTheme", "titleText", "acceptText", "rejectText", "onAccept", "onReject", "disabled", "rejectionLoading", "confirmationLoading", "popupStage"])),
                (_ctx.hasError)
                  ? (_openBlock(), _createBlock(_component_SomethingWrongOverlay, {
                      key: 2,
                      message: _ctx.error?.message,
                      customBackFunc: _ctx.goBackToBeginningOfAssessment
                    }, null, 8, ["message", "customBackFunc"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}